var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPilot(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.912 495.912",
    style: {
      enableBackground: "new 0 0 495.912 495.912"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "306.74,303.912 189.14,303.912 196.996,207.912 298.9,207.912 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "306.74,303.912 247.748,303.912 189.14,207.912 298.9,207.912 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M327.356,131.408c0,69.072-34.816,131.568-79.4,131.568c-44.6,0-79.4-62.496-79.4-131.568 c0-69.08,34.8-80.576,79.4-80.576C292.54,50.832,327.356,62.328,327.356,131.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M247.956,50.832c44.584,0,79.4,11.496,79.4,80.576c0,69.072-34.816,131.568-79.4,131.568"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M181.78,101.168c0,0-0.664,24.36-6.832,24.36l-4.544,4.544c0,0,0.968,29.552,2.6,30.856 c1.624,1.304-4.552,3.584-6.496-12.336c-1.952-15.92-2.928-50.672-2.928-50.672L181.78,101.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M314.132,101.168c0,0,0.664,24.36,6.832,24.36l4.544,4.544c0,0-0.968,29.552-2.6,30.856 c-1.624,1.304,4.552,3.584,6.496-12.336c1.952-15.92,2.928-50.672,2.928-50.672L314.132,101.168z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A02BBC"
    },
    points: "461.476,330.296 343.972,289.616 332.036,288.936 310.836,267.584 249.036,306.72  187.204,267.576 164.796,286.976 153.82,288.952 33.004,330.296 11.956,495.912 194.66,495.912 240.972,495.912 254.94,495.912  303.412,495.912 483.956,495.912 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#8720A0"
    },
    points: "79.956,495.912 240.972,495.912 254.94,495.912 303.412,495.912 483.956,495.912  461.476,330.296 343.972,289.616 324.236,287.472 310.836,267.584 249.036,306.72 187.204,267.576 249.132,306.792 153.82,288.952  33.004,330.296 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#6E0787"
    },
    points: "247.956,495.912 254.94,495.912 303.412,495.912 483.956,495.912 461.476,330.296  343.972,289.616 315.468,289.912 310.836,267.584 248.628,306.76 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#58036D"
    },
    points: "399.956,495.912 483.956,495.912 461.476,330.296 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M210.428,222.352c-0.16-0.216-0.248-0.368-0.248-0.368S210.236,222.2,210.428,222.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M285.46,222.352c0.168-0.216,0.256-0.368,0.256-0.368S285.644,222.2,285.46,222.352z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A4554"
    },
    d: "M234.404,152.52c0,13.896-11.872,25.152-26.504,25.152c-14.648,0-26.536-11.256-26.536-25.152 s11.888-18.864,26.536-18.864C222.524,133.656,234.404,138.624,234.404,152.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M207.892,181.672c-16.832,0-30.536-13.072-30.536-29.152c0-14.528,11.136-22.864,30.536-22.864 c19.392,0,30.504,8.336,30.504,22.864C238.404,168.592,224.716,181.672,207.892,181.672z M207.892,137.656 c-14.952,0-22.536,5-22.536,14.864c0,11.664,10.112,21.152,22.536,21.152c12.416,0,22.504-9.488,22.504-21.152 C230.404,142.656,222.828,137.656,207.892,137.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M179.708,151.912h-11.752c-2.208,0-4-1.792-4-4s1.792-4,4-4h11.752c2.208,0,4,1.792,4,4 S181.916,151.912,179.708,151.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A4554"
    },
    d: "M259.348,152.52c0,13.896,11.88,25.152,26.528,25.152c14.632,0,26.512-11.256,26.512-25.152 s-11.88-18.864-26.512-18.864C271.228,133.656,259.348,138.624,259.348,152.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M285.876,181.672c-16.832,0-30.528-13.072-30.528-29.152c0-14.528,11.128-22.864,30.528-22.864 c19.392,0,30.512,8.336,30.512,22.864C316.396,168.592,302.708,181.672,285.876,181.672z M285.876,137.656 c-14.952,0-22.528,5-22.528,14.864c0,11.664,10.112,21.152,22.528,21.152s22.512-9.488,22.512-21.152 C308.396,142.656,300.812,137.656,285.876,137.656z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M327.956,151.912h-16c-2.208,0-4-1.792-4-4s1.792-4,4-4h16c2.208,0,4,1.792,4,4 S330.164,151.912,327.956,151.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M260.292,162.216c-2.208,0-4-1.792-4-4c0-5.184-4.232-9.408-9.448-9.408 c-5.168,0-9.384,4.224-9.384,9.408c0,2.208-1.792,4-4,4c-2.208,0-4-1.792-4-4c0-9.6,7.8-17.408,17.384-17.408 c9.616,0,17.448,7.808,17.448,17.408C264.292,160.424,262.5,162.216,260.292,162.216z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.006,
    y: 257.133,
    transform: "matrix(-0.707 0.7072 -0.7072 -0.707 551.2094 365.8381)",
    style: {
      fill: "#CB3AEF"
    },
    width: 55.631,
    height: 79.935
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A02BBC"
    },
    points: "247.764,305.672 208.436,345.016 151.908,288.496 205.428,263.352  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.275,
    y: 257.124,
    transform: "matrix(0.707 0.7072 -0.7072 0.707 296.8549 -122.3531)",
    style: {
      fill: "#A02BBC"
    },
    width: 55.631,
    height: 79.927
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.412,
    y: 297.202,
    transform: "matrix(-0.9414 0.3374 -0.3374 -0.9414 283.9369 568.4448)",
    style: {
      fill: "#073D5B"
    },
    width: 80.323,
    height: 23.385
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.855,
    y: 305.421,
    transform: "matrix(-0.9413 0.3375 -0.3375 -0.9413 288.1164 575.7022)",
    style: {
      fill: "#042635"
    },
    width: 80.318,
    height: 14.952
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.676,
    y: 297.201,
    transform: "matrix(-0.9422 0.3351 -0.3351 -0.9422 283.276 568.904)",
    style: {
      fill: "#E5B342"
    },
    width: 9.768,
    height: 23.376
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.829,
    y: 302.593,
    transform: "matrix(-0.942 0.3357 -0.3357 -0.942 256.411 584.2481)",
    style: {
      fill: "#E5B342"
    },
    width: 9.76,
    height: 23.385
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.516,
    y: 301.888,
    transform: "matrix(-0.942 0.3355 -0.3355 -0.942 285.7842 572.9465)",
    style: {
      fill: "#D19315"
    },
    width: 9.768,
    height: 18.543
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.649,
    y: 307.283,
    transform: "matrix(-0.942 0.3357 -0.3357 -0.942 258.7669 588.381)",
    style: {
      fill: "#D19315"
    },
    width: 9.76,
    height: 18.545
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.032,
    y: 297.198,
    transform: "matrix(0.9414 0.3374 -0.3374 0.9414 127.7395 -117.2462)",
    style: {
      fill: "#073D5B"
    },
    width: 80.323,
    height: 23.385
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.623,
    y: 305.367,
    transform: "matrix(0.9413 0.3375 -0.3375 0.9413 129.0453 -116.573)",
    style: {
      fill: "#042635"
    },
    width: 80.318,
    height: 14.952
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.361,
    y: 297.235,
    transform: "matrix(0.9421 0.3354 -0.3354 0.9421 126.8522 -116.6797)",
    style: {
      fill: "#E5B342"
    },
    width: 9.76,
    height: 23.385
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.167,
    y: 302.597,
    transform: "matrix(0.942 0.3357 -0.3357 0.942 129.646 -121.4257)",
    style: {
      fill: "#E5B342"
    },
    width: 9.76,
    height: 23.385
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 395.463,
    y: 301.906,
    transform: "matrix(0.942 0.3357 -0.3357 0.942 127.6903 -116.3343)",
    style: {
      fill: "#D19315"
    },
    width: 9.76,
    height: 18.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.365,
    y: 307.301,
    transform: "matrix(0.942 0.3357 -0.3357 0.942 130.3663 -121.0238)",
    style: {
      fill: "#D19315"
    },
    width: 9.76,
    height: 18.545
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D19315"
    },
    cx: 247.956,
    cy: 347.888,
    r: 5.352
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D19315"
    },
    cx: 247.956,
    cy: 387.352,
    r: 5.352
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D19315"
    },
    cx: 247.956,
    cy: 426.792,
    r: 5.352
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#D19315"
    },
    cx: 247.956,
    cy: 466.312,
    r: 5.352
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A02BBC"
    },
    points: "195.1,335.912 33.948,335.912 34.116,331.368 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#58036D"
    },
    points: "303.316,338 455.956,334.712 455.956,331.416 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A02BBC"
    },
    d: "M348.924,76.48c0,30.016-49.512,25.68-100.968,25.68c-51.472,0-100.968,4.336-100.968-25.68 S196.492,0,247.956,0C299.412,0.008,348.924,46.464,348.924,76.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8720A0"
    },
    d: "M247.956,0.008c51.456,0,100.968,46.456,100.968,76.48c0,30.016-49.512,25.68-100.968,25.68 c-51.472,0-100.968,4.336-100.968-25.68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58036D"
    },
    d: "M247.956,0.008c51.456,0,100.968,46.456,100.968,76.48c0,30.016-49.512,25.68-100.968,25.68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M334.684,97.24c0,5.04-38.824,17.24-86.728,17.24c-47.912,0-86.744-12.2-86.744-17.24 s38.832-9.136,86.744-9.136C295.86,88.104,334.684,92.2,334.684,97.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58036D"
    },
    d: "M187.204,403.912c0,1.616-1.304,4-2.912,4H91.38c-1.624,0-2.936-2.384-2.936-4l0,0 c0-1.608,1.312-4,2.936-4h92.912C185.9,399.912,187.204,402.304,187.204,403.912L187.204,403.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#58036D"
    },
    d: "M187.204,419.912c0,1.616-1.304,4-2.912,4H91.38c-1.624,0-2.936-2.384-2.936-4l0,0 c0-1.616,1.312-4,2.936-4h92.912C185.9,415.912,187.204,418.296,187.204,419.912L187.204,419.912z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "239.22,54.12 227.524,42.424 196.66,42.424 208.356,49.896 221.348,49.896 225.58,54.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "249.148,66.472 239.732,57.048 214.844,57.048 224.268,63.072 234.756,63.072  238.156,66.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "227.508,67.44 232.724,72.64 246.444,72.64 241.252,69.32 235.46,69.32 233.588,67.44  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "256.692,54.12 268.388,42.424 299.252,42.424 287.556,49.896 274.564,49.896 270.332,54.12  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "246.764,66.472 256.18,57.048 281.068,57.048 271.644,63.072 261.156,63.072  257.764,66.472  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "268.404,67.44 263.188,72.64 249.468,72.64 254.66,69.32 260.452,69.32 262.324,67.44  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M367.956,439.224c0,3.312-1.336,6-4,6l0,0c-2.664,0-4-2.688-4-6v-56.832c0-3.312,1.336-6,4-6l0,0 c2.664,0,4,2.688,4,6V439.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC114"
    },
    d: "M367.956,451.624c0,1.8-2.56,3.24-4,3.24l0,0c-1.44,0-4-1.448-4-3.24v-30.72 c0-1.792,2.56-3.24,4-3.24l0,0c1.44,0,4,1.456,4,3.24V451.624z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC114"
    },
    points: "359.956,423.912 319.956,423.912 319.956,420.968 359.956,407.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC114"
    },
    points: "367.956,423.912 399.956,423.912 399.956,420.968 367.956,407.152  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC114"
    },
    points: "359.956,453.04 345.308,457.216 345.308,454.8 359.956,443.136  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFC114"
    },
    points: "364.332,453.04 378.996,457.216 378.996,454.8 364.332,443.136  "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPilot);
export default __webpack_public_path__ + "static/media/pilot.76c799ba534d388b1413667c220d17b4.svg";
export { ForwardRef as ReactComponent };